<nav
  aria-label="Left-Sidebar"
  tabindex="-1"
  class="right-side-nav right-side-nav-progressbar"
  id="side-navigation"
  [ngClass]="sidebarDesktop ? 'collapse-menu' : ''"
  [ngClass]="sidebarMobile ? 'active' : ''"
>
  <div class="right-side-nav-inner">
    <div class="nav-logo-section" [ngClass]="isDevMode ? 'dev-mode' : ''">
      <a [routerLink]="routeLink" class="dash-logo d-flex w-100" [ngClass]="{ 'custom-display': icon }">
        <ng-container *ngIf="!icon">
          <img [src]="logoSRCLG" class="logo-one m-auto" alt="" />
          <img [src]="logoSRCSM" class="logo-two" alt="" />
        </ng-container>
        <ng-container *ngIf="icon">
          <i 
            [class]="icon"
            [ngStyle]="{
              'font-size':fontSize,
              'color':iconColor
            }"
          ></i>
        </ng-container>
      </a>
      <div class="text-logo" *ngIf="isAppNameVisible">{{ appName }}</div>
      <div class="btn-collapse-nav">
        <a
          (click)="toggleDesktop(true)"
          [ngClass]="sidebarDesktop ? 'collapsed-menu' : ''"
          class="button-collapse shadow"
          id="collapse-nav"
          ><i class="icon-chv-right"></i
        ></a>
      </div>

      <!--  mobile  -->
      <div class="mobile-menu-div desktop-hidden">
        <button
          class="navbar-toggler mobile-menu-button"
          (click)="toggleMobile()"
          id="menu-open"
          type="button"
        >
          <span class="navbar-toggler-icon"> <i class="icon-menu"></i> </span>
        </button>
      </div>
      <!--  End of mobile  -->
    </div>
    <div class="col-md-12 m-2 dev-text text-logo" title="Development" *ngIf="isDevMode">
      Development
    </div>

    <div
      class="right-side-menu"
      id="dashboard-menu-clone"
      [ngClass]="sidebarMobile ? 'active' : ''"
    >
      <div class="right-side-inner">
        <!--  mobile  -->
        <a
          href="javascript:void(0)"
          class="closebtn desktop-hidden"
          (click)="toggleMobile()"
          id="menu-closed"
        >
          <i class="icon-close"></i>
        </a>
        <!--  End of mobile  -->

        <div class="group-user-drop-nav-list">
          <ng-container *ngTemplateOutlet="userProfile"></ng-container>
          <div class="side-nav-item accordion" id="menu-collapse">
            <ul class="main-listing mb-4">
              <app-side-navigation [navigations]="navigation" (loadDefaultTable)="loadDefaultTablePage($event)"></app-side-navigation>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--  mobile  -->
    <div id="cd-shadow-layer" class="menu-closed backdrop-menu-layer"></div>
    <!--  End of mobile  -->
  </div>
</nav>

<ng-template #userProfile>
  <div class="menu-cloned-one" id="menu-cloned-one">
    <div class="nav-dashboard-right nav-dashboard-new-custom-right">
      <div class="user-drop-down">
        <div
          class="dropdown drop-left dropdown-custom-top dropdown-new-sb"
        >
          <a
            class="btn btn-default dropdown-toggle"
            href="#"
            role="button"
            id="dropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <div class="user-profile">
              <div class="user-info">
                <h3>{{ fullName() }}</h3>
                <p>{{ email() }}</p>
              </div>
            </div>
          </a>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <form>
              <ul>
                <li>
                  <a
                    class="dropdown-item"
                    routerLink="/user/profile"
                  >
                    <span class="common-icon icon-edit-2"></span>
                    <span class="text">Edit Profile</span></a
                  >
                </li>
                <li *ngIf="showAppLibraryInSidebar$ | async">
                  <a class="dropdown-item" routerLink="/apps">
                    <span class="common-icon icon-apps"></span>
                    <span class="text">Apps</span></a
                  >
                </li>
                <li *ngIf="isSuperAdmin && !isImpersonate">
                  <a class="dropdown-item" routerLink="/company">
                    <span class="common-icon icon-person"></span>
                    <span class="text">Account Manager</span></a
                  >
                </li>
                <li *ngIf="isBillingAdmin">
                  <a class="dropdown-item" [routerLink]="'/company/'+companyId">
                    <span class="common-icon icon-person"></span>
                    <span class="text">Company Details</span></a
                  >
                </li>
                <li *ngIf="isBillingAdmin">
                  <a class="dropdown-item" routerLink="/user/billing">
                    <span class="common-icon icon-person"></span>
                    <span class="text">Billing Admin</span></a
                  >
                </li>
                <li *ngIf="isSuperAdmin && !isImpersonate">
                  <a class="dropdown-item" routerLink="/clients">
                    <span class="common-icon icon-people"></span>
                    <span class="text">Manage Clients</span></a
                  >
                </li>
                <li *ngIf="isSuperAdmin && !isImpersonate">
                  <a class="dropdown-item" (click)="executeTodayFormulas()">
                    <i class="common-icon icon-restart"></i>
                    <span class="text">Run Today Formulas</span></a
                  >
                </li>
                <li *ngIf="isHelpWidgetShow">
                  <a
                    href="https://support.opengov.com/"
                    target="_blank"
                    rel="noopener"
                    class="dropdown-item"
                  >
                    <i class="common-icon icon-help"></i>
                    <span class="text">Help</span></a
                  >
                </li>
                <li *ngIf="!isImpersonate && !isHideLogoutInPspShellEnabled" class="logout-li">
                  <a (click)="logout()" class="dropdown-item">
                    <span class="common-icon icon-logout"></span>
                    <span class="text">Logout</span></a
                  >
                </li>
                <li *ngIf="isImpersonate" class="logout-li">
                  <a
                    (click)="restoreSuperAdmin()"
                    class="dropdown-item"
                  >
                    <span class="common-icon icon-refresh"></span>
                    <span class="text">End Impersonate User</span></a
                  >
                </li>
              </ul>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
